/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Selectalisting2Inputs */

const en_selectalisting2 = /** @type {(inputs: Selectalisting2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a listing`)
};

const de_selectalisting2 = /** @type {(inputs: Selectalisting2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort auswählen`)
};

/**
* | output |
* | --- |
* | "Select a listing" |
*
* @param {Selectalisting2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const selectalisting2 = /** @type {((inputs?: Selectalisting2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Selectalisting2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_selectalisting2(inputs)
	return de_selectalisting2(inputs)
});
export { selectalisting2 as "selectAListing" }